import * as yup from 'yup';

export const dutchAuctionSchema = yup.object().shape({
  amount: yup
    .string()
    .test({
      name: 'amount',
      test: (value, context) => {
        const currentPrice = context.options.context?.currentPrice;
        const balance = context.options.context?.balance;

        if (!value) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Required'
          });
        }

        if (+value < +currentPrice) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Bid must be at least as big as the current price'
          });
        }

        if (+value > +balance) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Insufficient balance'
          });
        }

        return true;
      }
    })
    .required(),
  token: yup
    .object()
    .shape({
      contractAddress: yup.string().required(),
      name: yup.string().required(),
      symbol: yup.string().required(),
      decimals: yup.number().required()
    })
    .required()
});
